__turbopack_context__.v({
  "replyBoxWrapper": "r-sL5G_replyBoxWrapper",
  "signInButton": "r-sL5G_signInButton",
  "signInContainer": "r-sL5G_signInContainer",
});
